<!-- Modal envio de SMS -->
<div class="simple-modal" [ngClass]="{'show': showModal, 'close' : !showModal}">
  <div class="simple-modal-wrapper" [ngClass]="{'show': showModal, 'close' : !showModal}">
    <ng-content></ng-content>
  </div>
</div>